<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-file-alt"></i>&nbsp;<span *ngIf="!isEdit" i18n>Add New Page</span>
    <span *ngIf="isEdit" i18n>Update Page</span>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" [formEditablePermission]="form">
    <div class="row">
      <div class="col-4">
        <app-select-search
          [items]="availableWebsitePageTypes"
          [ctrl]="form.get('type')"
          [multiple]="false"
          bindValue="id"
          bindLabel="label"
          i18n-placeholder
          placeholder="Page Type"
          [inline]="false"
        >
          <ng-container class="error-container">
            <mat-error> <ng-container i18n>Page Type is required</ng-container></mat-error>
          </ng-container>
        </app-select-search>
      </div>
      <div class="col-4">
        <mat-form-field2>
          <app-select
            [items]="availableWebsitePageGroups"
            [multiple]="false"
            [searchable]="true"
            formControlName="group"
            required
            i18n-placeholder
            placeholder="Page Group"
            searchPlaceholder="Search or Create Group"
            i18n-searchPlaceholder
            i18n-matTooltip
            matTooltip="Page groups allow you to create dropdown menus by placing multiple pages into the same group. The group name will become the menu title. The default group places each page individually on the toolbar."
            matTooltipPosition="above"
          >
            <mat-error *ngIf="form.get('group').touched && form.get('group').hasError('required')">
              <ng-container i18n>Group is required</ng-container>
            </mat-error>
            <ng-template
              selectActionButton
              let-searchText="searchText"
              *ngIf="data.website.type === websiteTypes.RentalWebsite"
            >
              <button
                type="button"
                mat-button
                (click)="addGroup(searchText)"
                *ngIf="searchText && !isGroupExists(searchText)"
              >
                <i class="far fa-plus"></i> <ng-container i18n>Add Group</ng-container>
                <span class="text-dark ml-1">"{{ searchText }}"</span>
              </button>
            </ng-template>
          </app-select>
        </mat-form-field2>
      </div>
      <div class="col-4" *ngIf="data.website.type === websiteTypes.RentalWebsite">
        <mat-form-field2 class="mat-block">
          <app-select
            [items]="availableWebsitePageOrders"
            formControlName="order"
            bindLabel="label"
            bindValue="id"
            [multiple]="false"
            i18n-placeholder
            placeholder="Toolbar Link Order"
            i18n-matTooltip
            matTooltip="Link order allows you to change the order of your pages on the toolbar or in a group. The lowest link order in a group is the overall order of that group."
            matTooltipPosition="above"
            required
          >
          </app-select>
          <mat-error *ngIf="form.get('order').touched && form.get('order').hasError('required')">
            <ng-container i18n>Toolbar Link Order is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
    </div>

    <!-- Content Page -->
    <div class="row" *ngIf="form.get('type').value === websitePageTypes.Content">
      <div class="col-8">
        <mat-form-field2 class="mat-block">
          <input type="text" matInput required i18n-placeholder placeholder="Page Title" formControlName="title" />
          <mat-error *ngIf="form.get('title').touched && form.get('title').hasError('required')">
            <ng-container i18n>Page Title is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-4">
        <mat-form-field2 class="mat-block">
          <input type="text" matInput required i18n-placeholder placeholder="Link Title" formControlName="linkTitle" />
          <mat-error *ngIf="form.get('linkTitle').touched && form.get('linkTitle').hasError('required')">
            <ng-container i18n>Link Title is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-12">
        <editor [init]="editorOptions" [formControl]="form.get('body')" [initialValue]="form.get('body').value">
        </editor>
        <mat-error *ngIf="form.get('body').touched && form.get('body').hasError('required')" class="ml5">
          <ng-container i18n>Page Content is required</ng-container>
        </mat-error>
      </div>
    </div>
    <!-- External Link-->
    <div class="row" *ngIf="form.get('type').value === websitePageTypes.ExternalLink">
      <div class="col-8">
        <mat-form-field2 class="mat-block">
          <input
            type="text"
            matInput
            required
            i18n-placeholder
            placeholder="Absolute Link URL: (e.g. https://www.tokeet.com)"
            formControlName="linkurl"
          />
          <mat-error *ngIf="form.get('linkurl').touched && form.get('linkurl').hasError('required')">
            <ng-container i18n>URL is required</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('linkurl').touched && form.get('linkurl').hasError('url')">
            <ng-container i18n>URL is invalid</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-4">
        <mat-form-field2 class="mat-block">
          <input type="text" matInput required i18n-placeholder placeholder="Link Title" formControlName="linkTitle" />
          <mat-error *ngIf="form.get('linkTitle').touched && form.get('linkTitle').hasError('required')">
            <ng-container i18n>Link Title is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
    </div>
    <!-- Internal Link -->
    <div class="row" *ngIf="form.get('type').value === websitePageTypes.InternalLink">
      <div class="col-8">
        <mat-form-field2 class="mat-block">
          <input
            type="text"
            matInput
            required
            i18n-placeholder
            placeholder="Internal Page Link Title"
            formControlName="linkurl"
          />
          <mat-error *ngIf="form.get('linkurl').touched && form.get('linkurl').hasError('required')">
            <ng-container i18n>Internal Page Link Title is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-4">
        <mat-form-field2 class="mat-block">
          <input type="text" matInput required i18n-placeholder placeholder="Link Title" formControlName="linkTitle" />
          <mat-error *ngIf="form.get('linkTitle').touched && form.get('linkTitle').hasError('required')">
            <ng-container i18n>Link Title is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button
    (click)="onSave(form)"
    [disabled]="1 | isReadonlyRole"
    type="button"
    class="btn btn-secondary-info create-btn"
  >
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>Save</ng-container>
  </button>
</div>
